exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".loadingBar{height:4px;width:100%;position:fixed;top:0;overflow:hidden;z-index:1}.loadingBar:before{display:block;position:relative;content:\"\";left:-200px;width:200px;height:3px;background-color:red;animation:loading 4s linear infinite}@keyframes loading{0%{left:-60%;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/LoadingBar/style.css
// module id = 591
// module chunks = 1